import { connect } from "react-redux";
import { contactFlyer } from "actions/flyer";
import { closeModal } from "actions/modals";
import { showInfo } from "actions/notification";

import Translate from "utils/translate";

import FlyerContactModal from "./FlyerContactModal";

const { t } = new Translate("FlyerContactModal");

const mapDispatchToProps = (dispatch, { assetID }) => ({
  onSubmit: async (values) => {
    await dispatch(contactFlyer(assetID, values));
    dispatch(showInfo(t("successTitle"), t("successBody")));
    dispatch(closeModal("FlyerContactModal"));
  },
});

export default connect(null, mapDispatchToProps)(FlyerContactModal);
